import type { ExportJobSettings, JobDestinationBinding } from '../shared/desktop-api';

// Two rules Export and the rail share. They came from the empty Needs review list's export
// scenes (ExportNextStep), which were removed on 2026-10-31: the work screen's one export line
// (FirstExportCard) took their last job, "Export is off" with Turn on.

/**
 * A Content Central binding still delivers when it is connected, or when it needs attention
 * for only some of its types. Export's own pause and the rail both use this one rule.
 */
export function bindingDeliversSomeTypes(
  binding: Pick<JobDestinationBinding, 'status' | 'documentTypes'>,
): boolean {
  if (binding.status === 'connected') return true;
  if (binding.status !== 'needs-attention') return false;
  const held = binding.documentTypes.filter((type) => type.holdReason).length;
  return held > 0 && held < binding.documentTypes.length;
}

/**
 * The engine's sentence when an automatic folder export ("as soon as ready", "once a day")
 * could not start its last run, for example a folder it may no longer write to. Null for a
 * manual export (Export now says so itself), for Content Central, and once a run starts again.
 */
export function folderExportHold(
  settings: Pick<
    ExportJobSettings,
    'enabled' | 'triggerMode' | 'destinationKind' | 'automaticHold'
  > | null,
): string | null {
  if (!settings?.enabled || settings.triggerMode === 'manual') return null;
  if ((settings.destinationKind ?? 'filesystem') !== 'filesystem') return null;
  return settings.automaticHold?.message?.trim() || null;
}
